import { API_BASE_URL } from '../config';

/**
 * SoftDebug live SSE URL (MQTT → server → browser).
 * EventSource không gắn header → token qua query.
 */
export function buildDebugStreamUrl(inverterId) {
  if (!inverterId) {
    return null;
  }
  const token = typeof window !== 'undefined'
    ? window.localStorage.getItem('api-token')
    : null;
  if (!token) {
    return null;
  }
  const base = API_BASE_URL || '';
  const qs = new URLSearchParams({ token });
  return `${base}/api/inverters/${inverterId}/debug/stream?${qs.toString()}`;
}
